module.exports = __webpack_public_path__ + "be767af8023f97f4b21d466720c499e9.png";